module.exports = __webpack_public_path__ + "img/hint_box.6b254d9c.svg";